import TextBox from "../../forms/inputs/TextBox";
import { InputBaseParams } from "../../forms/Form";

// Underline-only textbox specifically for researcher settings UI
const ResearcherTextBox = ({
  name,
  label,
  password,
  placeholder,
  rules,
  className
}: InputBaseParams & {
  password?: boolean;
  placeholder?: string;
  label?: string;
  className?: string;
}) => (
  <div className="w-full">
    {label && <p className="mb-2">{label}</p>}
    <TextBox
      name={name}
      placeholder={placeholder}
      rules={rules}
      password={password}
      className={
        className ||
        "w-full border-0 border-b border-gray-300 rounded-none focus:ring-0 focus:border-blue-600 px-0 py-2 bg-transparent"
      }
      errorClassName="!border-red-500"
    />
  </div>
);

export default ResearcherTextBox;




